import { render, staticRenderFns } from "./ProcessDashBoard.vue?vue&type=template&id=0d6649c3&scoped=true"
import script from "./ProcessDashBoard.vue?vue&type=script&lang=js"
export * from "./ProcessDashBoard.vue?vue&type=script&lang=js"
import style0 from "./ProcessDashBoard.vue?vue&type=style&index=0&id=0d6649c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6649c3",
  null
  
)

export default component.exports